import { ValidationProvider, ValidationObserver, localize, extend } from 'vee-validate'
import ja from 'vee-validate/dist/locale/ja'

// ルール設定
import * as rules from 'vee-validate/dist/rules'
for (let rule in rules) {
  extend(rule, rules[rule])
}
extend('userCodeRegex', (value) => {
  return /^[a-zA-Z0-9._]+$/.test(value) || '{_field_} は半角英数記号の8～15文字で入力ください';
});
extend('passwordRegex', (value) => {
  return /^[a-zA-Z0-9_]+$/.test(value) || '{_field_} は半角英数記号の8～16文字で入力ください';
});
extend('tagLength', (value) => {
  return value.length <= 5 || '{_field_} は5個以内で選択ください';
});
extend('url', (value) => {
  return /https?:\/\/[-_.!~*'()a-zA-Z0-9;/?:@&=+$,%#]+/g.test(value) || '正しいURLを入力してください';
});
extend('availableSymbol', (value) => {
  return /^[0-9a-zA-Z\-!"#$%&'()*,./:;<=>?@[\]^_`{|}~]*$/.test(value) || '使用できない文字が使われています';
});

extend('required_with', {
  params: ['target'],
  validate(value, { target }) {
    if (!target) return true; 

    if (target.length === 0) {
      return ['', null, undefined].indexOf(value) === -1;
    }

    return true;
  },
  computesRequired: true,
  message: '{target}が入力されていない場合は、{_field_} を入力してください。'
});

// 日本語化
localize('ja', ja)

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
  },
};